import { ReactElement } from "react";
import { Box, Typography } from "@mui/material";

const ThankyouPage = (): ReactElement => {
  // UI Elements
  return (
    <Box className="thank-you-wrapper">
      <img
        src="/images/app-logo.svg"
        alt="Ezifin Logo"
        className="check-circle-style"
      />

      <Typography variant="h1" className="my-1 title">
        Thank you for verifying your identity
      </Typography>
    </Box>
  );
};

export default ThankyouPage;
